import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// libs
import { UISharedModule } from '@macs-frontend/features';

const MODULES = [CommonModule, FormsModule, ReactiveFormsModule, UISharedModule];

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES],
})
export class UIModule {}
